var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import qs from 'qs';
import { cookie } from '@plat-components/utils2';
export function openShareWindow(base, param, fn) {
    var url = base + qs.stringify(param);
    window.open(url, '', 'width=760, height=640, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, location=yes, resizable=no, status=no');
    return typeof fn == 'function' ? fn() : false;
}
export function popTips(str, $dom, $root) {
    var $father = $root.getElementsByClassName('bili-share-pc')[0];
    var div = document.createElement('div');
    div.className = 'popTips';
    div.innerHTML = str;
    div.style.left = $dom.offsetLeft - 32 + 'px';
    $father.appendChild(div);
    setTimeout(function () {
        var _a;
        (_a = div.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(div);
    }, 1500);
}
export function setChannelKey(url, type) {
    var hashSplit = url.split('#');
    var hash = hashSplit[1] ? "#" + hashSplit[1] : '';
    var searchSplit = (hashSplit[0] || '').split('?');
    var query = (searchSplit[1] || '').split('&');
    var shareQuery = __assign(__assign({}, qs.parse(query) || {}), { share_source: type, share_medium: 'web', bbid: cookie.getCookie('buvid3') || '', ts: new Date().getTime() });
    var paramStr = generateQueryString(shareQuery);
    return searchSplit[0] + "?" + paramStr + hash;
}
export function protoShare(share) {
    share.link = protocolReg(share.link);
    share.pics = protocolReg(share.pics);
    return share;
}
function generateQueryString(obj) {
    return Object.keys(obj)
        .map(function (key) { return key + "=" + encodeURIComponent(obj[key] || ''); })
        .join('&');
}
export function protocolReg(url) {
    if (url === void 0) { url = ''; }
    if (url.indexOf('https') == -1) {
        url = url.replace(/(\w+:)?\/\//, 'https://');
    }
    return url;
}
